import { render } from "./OcrFileList.vue?vue&type=template&id=2aea7b50"
import script from "./OcrFileList.vue?vue&type=script&lang=js"
export * from "./OcrFileList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__